import React, { useEffect, useState } from 'react'
import InfoIcon from '@mui/icons-material/Info';
import { Collapse, IconButton, Tooltip } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { labelMappings } from '../utils/utils';
import { useCouponAlert } from '../context/CouponAlert';
import { CouponBoxTypes } from '../types';
import RequiredFieldIndicator from '../../../components/popup/requiredField';
import { isOnlyDateUpdate } from '../services/services';
import { useSelector } from 'react-redux';

function CouponBox(props: CouponBoxTypes) {
  const { children, header, infoIconText, disabled, collapsible, open = false, showBorder, hideDropDown, RequiredFieldIndicator, onBeforeOpen , alertMessage} = props;
  const [boxOpen, setBoxOpen] = useState<boolean>(false);
  const { showAlert } = useCouponAlert();
  const { couponEditType } = useSelector((state: any) => state?.manageCoupons?.data);

  const handleOpen = () => {
    onBeforeOpen && onBeforeOpen();

    if (disabled) {
      showAlert(alertMessage ?? labelMappings["coupon-box-diabled-click-alert"], 'warning')
      setBoxOpen(false);
      return;
    }
    setBoxOpen((pre) => !pre);
  }

  useEffect(() => {
    if (disabled) setBoxOpen(false);
  }, [disabled])


  useEffect(() => {
    if (collapsible)
      setBoxOpen(open);
  }, [open])


  return (
    <div className={`coupon-box-wrapper ${disabled ? 'coupon-box-wrapper-disabled' : ''} ${showBorder && !disabled ? "coupon-box-wrapper-border" : ""} `}>
      <div className="coupon-box-header-wrapper" style={{ cursor: 'pointer' }} onClick={handleOpen}>
        <div className="coupon-box-header-left">
          {header} {RequiredFieldIndicator}
          {infoIconText && infoIconText !== "" && <span style={{ height: '18px' }}>
            <Tooltip title={infoIconText} arrow placement="top">
              <InfoIcon sx={{ fontSize: '18px !important' }} />
            </Tooltip>
          </span>}
        </div>
        {
          collapsible &&
          <div className="coupon-box-header-right">
            <IconButton size="small" className="sku-group-selector-collapse-ToggleBtn" onClick={(e) => { e.stopPropagation(); handleOpen() }}>
              {!hideDropDown && (boxOpen ? <KeyboardArrowUp className='sku-group-selector-collapse-ToggleBtn-icon' /> : <KeyboardArrowDown className='sku-group-selector-collapse-ToggleBtn-icon' />)}
            </IconButton>
          </div>
        }

      </div>
      <Collapse timeout="auto" in={collapsible ? boxOpen : true} className={`coupon-box-content-wrapper ${collapsible ? boxOpen ? 'coupon-box-content-wrapper-open' : 'coupon-box-content-wrapper-close' : 'coupon-box-content-wrapper-open'}`}>
        {
          disabled && <div
            className="coupon-dashboard-disable-overlay"
            onClick={() => (isOnlyDateUpdate() && couponEditType === "edit") ? '' : showAlert(labelMappings['MARKET_DETAILS_DISABLED'], 'info')} />
        }
        {children}
      </Collapse>
    </div>
  )
}

export default CouponBox;